import { type SyntheticEvent, useState } from "react";
import { useIntl } from "react-intl";
import { sendAnalyticsInteractionEvent } from "src/analytics/sendAnalyticsEvent";
import styled from "styled-components";
import { Button } from "src/design-system/components/Button/Button";
import { Dialog } from "../../../../components/Dialog/Dialog";
import {
  color,
  fontSize,
  fontWeight,
  lineHeight,
  spacing,
} from "../../../../theme";
import type { UserProfile } from "../../../utils/user";
import { CloseButton } from "../../CloseButton/CloseButton";
import { ManageProfile } from "../ManageProfile";
import { messages } from "../ManageProfile.messages";

type Props = {
  user: UserProfile;
};
export function ManageProfileDialog({ user }: Props) {
  const [isOpen, setIsOpen] = useState(false);
  const intl = useIntl();

  function handleManageProfileClick() {
    sendAnalyticsInteractionEvent({
      category: "UserAccount",
      action: "Click:ManageProfile",
    });
    setIsOpen(true);
  }

  function handleManageProfileClose() {
    sendAnalyticsInteractionEvent({
      category: "UserProfile",
      action: "Click:Close",
    });
    setIsOpen(false);
  }

  return (
    <>
      <Button
        size="medium"
        variant="secondary"
        onClick={handleManageProfileClick}
      >
        {intl.formatMessage(messages.manageProfile)}
      </Button>
      <Dialog
        isOpen={isOpen}
        onBackdropClicked={(e) => {
          e.stopPropagation();
          sendAnalyticsInteractionEvent({
            category: "UserProfile",
            action: "Click:Shadow",
          });
          setIsOpen(false);
        }}
        variant="default"
      >
        <Container onClick={(e: SyntheticEvent) => e.stopPropagation()}>
          <Heading>
            <CloseButton onClick={handleManageProfileClose} />
            <Title>{intl.formatMessage(messages.updateYourDetails)}</Title>
          </Heading>

          <ManageProfile user={user} />
        </Container>
      </Dialog>
    </>
  );
}

const Container = styled.div`
  padding: ${spacing.xxl};
  max-width: 432px;
  height: 512px;
  gap: ${spacing.xxl};
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;
const Heading = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  width: 100%;
`;
const Title = styled.h4`
  font-weight: ${fontWeight.semibold};
  font-size: ${fontSize.h2};
  line-height: ${lineHeight.snug};
  color: ${color.black};
  width: 100%;
`;
